import {
  CHROMA_RIBBED_FAILED,
  CHROMA_RIBBED_REQUEST,
  CHROMA_RIBBED_SUCCESS,
} from "app/redux/actions/SeriesProduct/ChromaRibbed/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const chromaRibbedReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case CHROMA_RIBBED_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case CHROMA_RIBBED_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case CHROMA_RIBBED_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
